import {VK} from "./VK";
import {Telegram} from "./Telegram";
import {Odnoklassniki} from "./Odnoklassniki";
import {Whatsapp} from "./Whatsapp";

export {
    VK,
    Telegram,
    Odnoklassniki,
    Whatsapp,
}
